import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row } from "react-bootstrap";
import "./Terms_conditions.css";
import { Link } from 'react-router-dom';

const Terms_conditions = () => {
    return (
        <section className="terms-section">
            {/* ======= Banner ======= */}
            <div className="terms-banner">
                <div className="overlay">
                    <h2 className="banner-title">TERMS AND CONDITIONS</h2>
                    <p className="breadcrumbs">
                        <Link to={"/"}>Home</Link>
                        <FontAwesomeIcon className='nextfafa' icon={faAngleRight} /> <span>  Terms and Conditions </span>
                    </p>
                </div>
            </div>
            {/* ======= Main Content ======= */}
            <Container>
                <div className="terms-content">
                    <Row>
                        <Col lg={12}>
                            <p className="last-updated">
                                <strong>Last Updated :</strong> 17 SEPT 2025
                            </p>
                            <p className="intro">
                                Welcome to <span>AI ORIGIN</span>. By accessing or using our
                                website, mobile app, or services (collectively, the “Services”),
                                you agree to comply with and be bound by these Terms and
                                Conditions. Please read them carefully. If you do not agree, do
                                not use our Services.
                            </p>
                            <hr className='divider' />

                            <h5 className='text-title'>1. Acceptance of Terms</h5>
                            <p className="policy-text">
                                By using our Services, you confirm that you have read,
                                understood, and accepted these Terms & Conditions, along with our
                                Privacy Policy & any other applicable policies. These Terms apply
                                to all visitors, users, and others who access our Services.
                            </p>
                            <hr />

                            <h5 className='text-title'>2. Eligibility</h5>
                            <p className="policy-text">
                                -You must be at least 18 years old and legally capable of entering
                                into a binding contract to use the Services. <br /> <br />
                                - You must be at least 18 years old and legally capable of entering into a binding contract to use the Services.<br /> <br />
                                - By using the Services, you confirm that you meet these eligibility requirements.<br /><br />
                                - Use of the Services by anyone under 18 is strictly prohibited.<br /><br />
                            </p>
                            <hr />

                            <h5 className='text-title'> 3. Account Registration and Security</h5>
                            <p className='policy-text'>
                                - To access certain features, you may be required to create an account.
                                You must provide accurate, complete, and current information during registration.<br /><br />
                                - You are responsible for maintaining the confidentiality of your account credentials (username, password, etc.)
                                and for all activity that occurs under your account.<br /><br />
                                - You agree to notify us immediately if you suspect unauthorized use of your account.<br /><br />
                                - The company reserves the right to suspend or terminate accounts in cases of fraud, misuse, or violation of these Terms.
                            </p>
                            <hr />

                            <h5 className='text-title'>4. Services Provided</h5>
                            <p className='policy-text'>
                                - The website offers services including but not limited to mobile recharges,
                                bill payments, MLM/reward programs, and other digital transactions. <br /><br />
                                - We reserve the right to modify, suspend, or discontinue any service at any time, with or without notice. <br /><br />
                                - While we aim for accuracy in pricing and service availability, occasional errors may occur.
                                We are not liable for losses arising from such errors.<br /><br />
                            </p>
                            <hr />

                            <h5 className='text-title'>5. Transactions and Payments</h5>
                            <p className='policy-text'>
                                - All payments made through the website must comply with applicable laws and regulations. <br /><br />
                                - Transaction confirmation depends on external payment gateways and service providers;
                                delays or errors caused by third parties are beyond our control. <br /><br />
                                - Refunds, cancellations, or reversals will be handled according to our Refund Policy.<br /><br />
                                - Users are responsible for verifying all transaction details before confirming payments.<br /><br />
                            </p>
                            <hr />

                            <h5 className='text-title'>6. Rewards, MLM Programs, and Earning Opportunities</h5>
                            <p className='policy-text'>
                                - Any rewards, earnings, or commissions are subject to program rules and conditions.<br /><br />
                                - Participation in MLM or reward programs requires adherence to all applicable rules,
                                regulations, and legal requirements.<br /><br />
                                - The company is not responsible for losses resulting from non-compliance, inaccurate information, or misuse of the program.<br /><br />
                                - Rewards and earnings are calculated based on verified actions, and the company reserves the right to modify reward structures at any time.
                            </p>
                            <hr />

                            <h5 className='text-title'>7. User Conduct</h5>
                            <p className='policy-text'>You agree not to:</p>
                            <div className='sub-text'>
                                <p className='policy-text'>
                                    - Use the Services for any unlawful, fraudulent, or malicious purpose.<br /><br />
                                    - Engage in activities that disrupt or interfere with the website’s functionality or security.<br /><br />
                                    - Upload, post, or share content that is false, misleading, offensive, or violates the rights of others.<br /><br />
                                    - Attempt to gain unauthorized access to other users’ accounts, our systems, or data.<br /><br />
                                    - Use automated scripts, bots, or other tools to manipulate Services, rewards, or transactions.
                                </p>
                            </div>
                            <hr />

                            <h5 className='text-title'>8. Intellectual Property</h5>
                            <div className='sub-text'>
                                <p className='policy-text'>
                                    - All content on the website, including text, graphics, logos, software, and designs, is owned by
                                    [Your Company Name] or its licensors and is protected under intellectual property laws.<br /><br />
                                    - Users may not reproduce, distribute, modify, or create derivative works without prior written permission.
                                </p>
                            </div>
                            <hr />

                            <h5 className='text-title'>9. Limitation of Liability</h5>
                            <div className='sub-text'>
                                <p className='policy-text'>
                                    The Services are provided “as-is” and “as-available.”
                                    [Your Company Name] is not responsible for any direct, indirect, incidental,
                                    consequential, or punitive damages arising from the use or inability to use the Services.<br /><br />
                                    This includes, but is not limited to, loss of profits, data, or other intangible losses.
                                </p>
                            </div>
                            <hr />

                            <h5 className='text-title'>10. Privacy and Data Protection</h5>
                            <div className='sub-text'>
                                <p className='policy-text'>
                                    - Collection, storage, and processing of personal data is governed by our Privacy Policy.<br /><br />
                                    - By using the Services, you consent to the use of your data for account management,
                                    service delivery, marketing (if opted-in), and other purposes described in the Privacy Policy.<br /><br />
                                    - Sensitive information, such as payment details, is handled securely using encryption and industry-standard security measures.
                                </p>
                            </div>
                            <hr />

                            <h5 className='text-title'>11. Third-Party Services</h5>
                            <div className='sub-text'>
                                <p className='policy-text'>
                                    Our Services may integrate with third-party service providers,
                                    such as payment gateways or telecom operators. We are not responsible for any failure,
                                    delay, or error caused by third-party services. Users agree to comply with the terms and
                                    conditions of these third-party services.
                                </p>
                            </div>
                            <hr />

                            <h5 className='text-title'>12. Termination of Services </h5>
                            <div className='sub-text'>
                                <p className='policy-text'>
                                    We reserve the right to suspend or terminate your access to the Services
                                    at any time without prior notice if you violate these Terms. Termination does
                                    not limit our rights to take legal action or recover amounts owed.
                                </p>
                            </div>

                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    )
}

export default Terms_conditions